module.exports = __webpack_public_path__ + "static/media/slide-1-image.4e6c7351.svg";